import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import PropTypes from "prop-types";
import { themeSelector } from "../../ducks/shopping/selectors";
import Header from "./Header";
import Footer from "./Footer";

const Container = styled.div`
  height: 100vh;
  width: 100%;
`;

const Children = styled.div`
  width: 100%;
  min-height: 80vh;
  background-color: ${(props) => props.bgColor || "white"};
`;

const Layout = ({ children, canGoBack, className, canSearchHeader, idStoreDetail, catCatView, subCatCatView, famCatView, marginTopHeader }) => {
  
  const theme = useSelector(themeSelector);

  return (
    <Container className={className}>
      <Header canGoBack={canGoBack} canSearchHeader={canSearchHeader} idStoreDetail={idStoreDetail} catCatView={catCatView} subCatCatView={subCatCatView} famCatView={famCatView} marginTopHeader={marginTopHeader} />
      <Children bgColor={theme && theme.bodyBackgroundGeneral}>{children}</Children>
      <Footer />
    </Container>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  canGoBack: PropTypes.bool,
  className: PropTypes.string,
  canSearchHeader: PropTypes.bool,
  idStoreDetail: PropTypes.string,
  catCatView: PropTypes.string,
  subCatCatView: PropTypes.string,
  famCatView: PropTypes.string,
  marginTopHeader: PropTypes.string,
};

Layout.defaultProps = {
  canGoBack: false,
  className: undefined,
  canSearchHeader: false,
  idStoreDetail: null,
  catCatView: null,
  subCatCatView: null,
  famCatView: null,
  marginTopHeader: null,
};

export default Layout;
